<ng-container *transloco="let t">
  @if (item) {
    <div class="cart-item" [class.mobile]="mobileMode">
      @if (!mobileMode) {
        <div class="media-col">
          <app-picture
            class="picture"
            [alt]="item?.title || ''"
            [pictureUrl]="item.images[0] || ''"
            [width]="'124px'"
            [height]="'124px'"></app-picture>
          <div class="badge">{{ quantity || 1 }}</div>
        </div>
      }
      @if (!mobileMode) {
        <span class="fixed-space-16" aria-hidden="true"></span>
      }
      <div class="info-col">
        <div class="flex flex-row">
          @if (mobileMode) {
            <span class="fixed-space-24" aria-hidden="true"></span>
          }
          <p class="title">{{ item.title || '' }}</p>
        </div>

        @if (mobileMode) {
          <div class="badge">{{ quantity || 1 }}</div>
        }
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>

      <div class="info-col price">
        @if (item.id) {
          <strong class="price"> {{ (item.price | amount) || 0 }} </strong>
        }
        @if (item.id) {
          <span class="price crossed">
            {{ (item.originalPrice | amount) || 0 }}
          </span>
        }
      </div>
    </div>
    <div class="subtitle">
      @if (language === 'en') {
        You saved
      } @else {
        أنت وفرت
      }
      {{
        {
          amount: item.originalPrice.amount - item.price.amount,
          currency: item.price.currency
        } | amount
      }}!
    </div>
    <span class="fixed-space-4" aria-hidden="true"></span>
  }
  @if (insurance) {
    <ng-container>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <span class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </ng-container>

    <div class="cart-item" [class.mobile]="mobileMode">
      @if (!mobileMode) {
        <div class="media-col">
          <div class="picture">
            <popsy-icon-popsy-shield-4 class="icon"></popsy-icon-popsy-shield-4>
          </div>
          <div class="badge">{{ quantity || 1 }}</div>
        </div>
      }
      @if (!mobileMode) {
        <span class="fixed-space-16" aria-hidden="true"></span>
      }
      <div class="info-col">
        <div class="flex flex-row">
          @if (mobileMode) {
            <span class="fixed-space-24" aria-hidden="true"></span>
          }
          <p class="title insurance">{{ insurance?.description || 'Popsy Kafala' }}</p>
        </div>
        <p class="title insurance">for {{ item?.model }}</p>
        @if (mobileMode) {
          <div class="badge">{{ quantity || 1 }}</div>
        }
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <div class="info-col price">
        @if (insurance.id) {
          <strong class="price">
            {{ (insurancePrice() | amount) || 0 }}
          </strong>
        }
      </div>
    </div>
  }
</ng-container>
